import { withStyles } from "@material-ui/styles";
import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";

export const TextFieldCustom = withStyles((theme) => ({
    root: {
        borderRadius: "6px",

        "& fieldset": {
            borderColor: "#E7E8EA",
        },
        "& input:not([value='']) ~ fieldset": {
            borderColor: "#02599E !important",
        },
        "&:hover fieldset": {
            borderColor: "#02599E !important",
        },
        "& [class*=Mui-focused] fieldset": {
            borderColor: "#02599E !important",
            // borderWidth: '1px !important',
        },
        "&:focus": {
            outline: "none",
        },
        "& [class*=MuiFormLabel-root], & [class*=MuiInputBase-input]": {
            fontWeight: "400 ",
            fontSize: "14px",
            lineHeight: "16px",
            letterSpacing: "-0.01em",
        },
        "& [class*=MuiInputBase-input]": {
            color: "#011328",
        },
        "& label[class*=Mui-focused]": {
            color: "#02599E",
        },

        "& [class*=Mui-focused] [class*=MuiIconButton-label]": {
            color: "#02599E",
        },
        "& label[class*=MuiInputLabel-shrink]": {
            fontSize: "16px",
            color: "#02599E",
        },
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none",
        },
        "& [class*=MuiIconButton-root]": {
            "&:focus": {
                outline: "none",
            },
        },
        "& [class*=MuiOutlinedInput-notchedOutline]": {
            "&:focus": {
                outline: "none",
            },
        },
        "& [class*=MuiInputBase-root]": {
            background: "#fff",
        },
        "& label[class*=Mui-error]": {
            color: "#f44336",
            "& ~ [class*=MuiInputBase-root]": {
                "& > fieldset": {
                    borderColor: "#f44336 !important",
                },
            },
        },
        
        "& input:read-only ~ fieldset": {
            borderColor: "white !important",
        },

        "& label.Mui-disabled": {
            color: "rgba(0,0,0,0.4) !important",
            "&~[class*=MuiInputBase-root]": {
                "& > input": {
                    color: "rgba(0, 0, 0, 0.5)",
                },
                "& > [class*=MuiSelect-root]": {
                    color: "rgba(0, 0, 0, 0.5)",
                },
                "& > fieldset": {
                    borderColor: "rgba(0,0,0,0.1) !important",
                }
            },
        },
    },
}))(TextField);

export const TextFieldDate = withStyles((theme) => ({
    root: {
        background: "#fff",
        borderRadius: "6px",
        height: "38px",
        width: "190px",
        "& fieldset": {
            borderColor: "#E7E8EA",
        },
        "& input:not([value='']) ~ fieldset": {
            borderColor: "#02599E !important",
        },
        "& input:not([value=''])+[class*=MuiInputAdornment-root]": {
            "&>[class*=MuiIconButton-root]": {
                color: "#02599E",
            },
        },
        "&:hover fieldset": {
            borderColor: "#02599E !important",
        },
        "& [class*=Mui-focused] fieldset": {
            borderColor: "#02599E",
            // borderWidth: "1px !important",
        },
        "&:focus": {
            outline: "none",
        },
        "& [class*=MuiFormLabel-root], & [class*=MuiInputBase-input]": {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "16px",
        },
        "& [class*=MuiInputBase-input]": {
            color: "#011328",
        },
        "& [class*=MuiInputLabel-shrink]": {
            fontSize: "16px",
            color: "#02599E",
        },
        "& [class*=MuiIconButton-root]": {
            padding: "5px",
            marginRight: "5px",
            "&:focus": {
                outline: "none",
            },
        },
        "& [class*=MuiInputBase-adornedEnd]": {
            paddingRight: "0",
        },
        "& input:read-only ~ fieldset": {
            borderColor: "white !important",
        },
        "& input:read-only+[class*=MuiInputAdornment-root]>[class*=MuiIconButton-root]": {
            cursor: "default",
            "&:hover": {
                backgroundColor: "initial",
            },
        },
    },
}))(KeyboardDatePicker);
